/**
 * Created by DejanK on 3/17/2017.
 */
import angular from 'angular'

export default angular.module('rb.core.ui.form', [
  ])
